<h1 mat-dialog-title>Invite Users</h1>
<p>Invite new members by email to join your organization.</p>
@if (siteConfig$ | async; as siteConfig) {
    <div mat-dialog-content>
        <frog-invites [withLink]="false" [clientId]="siteConfig.client_id"></frog-invites>
    </div>
}
<mat-divider></mat-divider>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-stroked-button color="primary" (click)="send()">Send Invitations</button>
</div>
